export default "__VITE_ASSET__CJEf0ZYG__"